// import { Security } from "@mui/icons-material";
// import sandwich from "../../images/sunkIcon/1-sandwich.png";
// import football from "../../images/sunkIcon/2-football.png";
// import Grass from "../../images/sunkIcon/3-Grass.png";
// import Kindergarten from "../../images/sunkIcon/4-Kindergarten.png";
// import Firefox from "../../images/sunkIcon/5-Firefox.png";
// import Sunset from "../../images/sunkIcon/6-Sunset.png";
// import Guacamole from "../../images/sunkIcon/7-Guacamole.png";
// import things from "../../images/sunkIcon/8-Stranger-things.png";
// import Beach from "../../images/sunkIcon/9-Beach.png";

const questions = [
  {
    id: 1,
    title: "U.S Federal Government Spending (2025)",
    boldText: "",
    answer: "Private Good",
    actual: {
      Security: 22,
      Health: 27,
      Defense: 13,
      Unemployment: 10,
      Interest: 14,
      Veteran: 5,
      Other: 9
    },
    tooltip:{
      Security: "The Social Security function includes the two programs administered by the Social Security Administration: Old Age and Survivors Insurance and Disability Insurance.",
      Health: "Health includes Medicare (a health insurance program that primarily provides coverage for people aged 65 and older), Medicaid (insurance for low income households), and other direct health expenditures by the Federal Government.",
      Defense: "This is spending directed to the Department of Defense.",
      Unemployment: "This includes unemployment insurance, welfare payments, and other aid to low income individuals (like food and housing assistance).",
      Interest: "Interest payments on money the government has borrowed.",
      Veteran: "Spending by the department of Veteran's Affairs.",
      Other: "Other spending not listed above.",
    },

    description: 'The largest components of federal government spending are Social Security and Medicare (included under "Health" in this interactive). Both programs are mandatory. This means that to change this spending, Congress would need to pass new laws. Other spending categories you may be wondering about are Foreign Aid and Education. Foreign Aid is less than 1% of total federal spending. In terms of Education, most spending is done by states and local government. When you include those, education makes up about 13% of total government spending.',
  },
];

export default questions;
